<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      element-loading-text="加载中..."
    >
    <div class="container-wrap">
      <div class="container-left">
        <div class="card01">
          <card-hegu title="车流统计">
            <ball-custom :source="chartData"></ball-custom>
          </card-hegu>
        </div>
        <div class="card02">
          <card-hegu title="车流量趋势">
            <div class="card01-1">
              <day-control-hegu :timeType="timeType" :timeValue="timeValue" :isMini="true" @selected="getTrendDataByTimes" ref="dayControlRef"></day-control-hegu>
            </div>
            <div class="card01-2">
              <line-echarts-hegu :chartData="chartData2"></line-echarts-hegu>
            </div>
          </card-hegu>
        </div>
      </div>
      <div class="container-middle">
        <hegu-map-echart :bMapJson="bMapJson" :currentCode="code" :currentLevel="4" currentName="" :showBack="false" :poiParams="poiParams" :poiList="equipmentList" :heatData="heatData" @clickPoi="clickPoi"></hegu-map-echart>
      </div>
      <div class="container-right">
          <div class="right01">
            <tab-hegu :activeIndex="activeIndex" :list="list" @changeTab="changeTab"></tab-hegu>
          </div>
          <div class="right02">
            <card-hegu title="监控点详情">
              <div class="info-wrap">
                <el-select class="select-scenic-list" v-model="equipmentIndex" @change="selectHdl(equipmentIndex)">
                  <el-option v-for="(item,index) in equipmentList" :key="index" :label="item.equipmentName" :value="index"></el-option>
                </el-select>
                <div class="address-wrap">
                  <img src="@/assets/icon-4.png" alt="">
                  <div>{{info.equipmentLocation}}</div>
                </div>
                <div class="status-wrap">
                  <img src="@/assets/icon-6.png" alt="">
                  <div>{{info.onlineStatus == 1 ? '设备状态正常' : '设备状态异常'}}</div>
                </div>
                <div class="count-wrap">
                  <div class="enter">
                    <img src="@/assets/icon-3.png" alt="">
                    <div class="count-info">
                      <div class="count-title">实时入园人数</div>
                      <div class="count-num">{{inCountNum}}</div>
                    </div>
                  </div>
                  <div class="enter">
                    <img src="@/assets/icon-2.png" alt="">
                     <div class="count-info">
                      <div class="count-title">实时出园人数</div>
                      <div class="count-num">{{outCountNum}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </card-hegu>
          </div>
      </div>
    </div>
    </zj-layout-container>
    <el-dialog
      class="video-dialog"
      :append-to-body="true"
      :visible.sync="showVideo"
      @before-close="showVideo = false"
    >
    <flv-player-real-time-hegu-gb
        v-if="showVideo"
        ref="childVideo"
        class="videoBig-item"
        :currentIndex="0"
        :item="camera"
        />
        <!-- :cameraId="camera.equipmentCode"
        :cameraName="camera.equipmentName" -->
    </el-dialog>
  </div>
</template>

<script>
import { getTrendByTimes, getRealTimeData } from "@/api/src/bigData";
import { videoList } from "@/api/src/videoApiGb";
import {
  getEquipmentCode,
  listEquipment,
  getHeatVechicleData,
  getCarflow
} from "@/api/src/equipment";
// import bMapJson from "../../../../../../public/lib/echart/json/scenic/toutunhegu.json";
import ZJApp from '../../../../app';
const utils = ZJApp.ZJUtils;
import {mapActions} from 'vuex';
export default {
  name: "TrafficFlow",
  controller: "UI",
  action: "TrafficFlow",
  components: {
  },
  data() {
    return {
      code:'',
      bMapJson:'',
      // bMapJson:JSON.stringify(bMapJson),
      // 遮罩层
      loading: false,
      timeType:'hour',
      timeValue:24,
      list:['监测报表','热力图'],
      activeIndex:0,
      heatData:[],
      // 车流统计
      chartData:[
        { name: '今日入园', count: 0 },
        { name: '今日出园', count: 0 },
        { name: '在园车辆', count: 0 }
      ],
      // 车流趋势
      chartData2:{
        days:[],
        data:[],
      },
      equipmentList:[],
      poiParams:{
        color: "#30c5ff",
          type: "scatter",
          name: "equipmentName",
          valueField: "",
          symbol:'img_poi_white'
      },
      equipmentIndex:null,
      info:{
        equipmentLocation:'',
        code:'',
        onlineStatus:1
      },
      inCountNum:0,
      outCountNum:0,
      showVideo:false,
      camera:{},
      interval:null,
      monitorList:[]
    };
  },
  commented:{
  },
  mounted(){
    this.code = this.config.area.code
    this.submitIsShowbg(false)
    this.getMapJson()
    // this.getMonitorList()
    this.getEquipmentList()
    setTimeout(() => {
        this.interval=setInterval(()=>{
            this.refreshType();
        },180 * 1000);
    }, 200);
  },
  methods: {
    getMapJson(){
      getEquipmentCode('echartsMapJson').then(res =>{
            if(res.code == 200){
                this.bMapJson = res.data
            }
        })
    },
    getMonitorList(){
      videoList({page: 1,size: 999,condition:{deviceType:2}}).then(res => {
        this.monitorList = res.data.records || []
      })
    },
    ...mapActions(['submitIsShowbg']),
    clickPoi(data){
      this.camera = data
      this.showVideo = true
    },
    changeTab(index){
      this.activeIndex = index
      if(index == 1){
        this.getheatData()
      }else{
        this.refreshType()
        this.heatData = []
      }
    },
    refreshType(){
      var that=this;
      that.loading = true;
      utils.waitAll([
        getTrendByTimes('staCarAnalysis',this.getAreaTimeSearchParams3(this.config.area.type, this.config.area.code, 'hour')),
        getRealTimeData('staRealParking',{}),
        this.getTrendDataByTimes(),
        this.selectHdl(0),
        this.getheatData()
      ])
      .then(res => {
        that.loading = false;
        let chartData = JSON.parse(JSON.stringify(that.chartData))
        if(res[0].code == 0 && res[0].data && res[0].data.length){
          let inCountNum = 0, outCountNum = 0;
          res[0].data.map(item =>{
            inCountNum += item.countIn
            outCountNum += item.countOut
          })
          chartData[0].count = inCountNum
          chartData[1].count = outCountNum
          chartData[2].count = inCountNum - outCountNum >= 0 ? inCountNum - outCountNum : 0
        }else{
          chartData[0].count = 0
          chartData[1].count = 0
          chartData[2].count = 0
        }

        // if(res[1].code == 0 && res[1].data && res[1].data.length){
        //   let todayCountNum = 0
        //   res[1].data.map(item =>{
        //     todayCountNum += item.useNum
        //   })
        //   chartData[2].count = todayCountNum
        // }else{
        //   chartData[2].count = 0
        // }
        this.chartData = chartData
      }).catch((res =>{
        this.loading = false;
      }))
    },
    getheatData(){
      return new Promise(resolve =>{
        getHeatVechicleData({}).then(res =>{
          // console.log(res)
          // res.data.heatData[0].value = 18
          // res.data.heatData[0].lng = 87.350779
          // res.data.heatData[0].lat = 44.004226
          let heatData = []
          res.data.heatData.map(item =>{
            if(item.value > 0){
              heatData.push(item)
            }
          })
          if(this.activeIndex == 1){
            this.heatData= heatData
          }
           resolve(res)
        }).catch(() =>{
          resolve(null)
        });
      })
    },
    async getTrendDataByTimes(params){
      var that=this;
      if(!params){
          // params = this.getAreaTimeSearchParams3(this.config.area.type, this.config.area.code, this.timeType)
          params = await this.$refs.dayControlRef.refreshTime() 
      }
      return new Promise(resolve =>{
         getTrendByTimes("staCarAnalysis", params).then(res =>{
             resolve(res)
              if(res.code == 0 && res.data){
              let days = [], data = []
              res.data.map((x) => {
                days.push(that.timeFormatself(x.dataTime, params.timeType))
                data.push(x.countIn)
              });
              this.chartData2 = { days, data }
            }else{
              this.chartData2 = {
                days:[],
                data:[],
              }
            }
        }).catch(() =>{
          resolve(null)
        });
      })
    },
    getEquipmentList(){
      this.loading = true;
        getEquipmentCode("traffic-flow-code").then((response) => {
          listEquipment({ categoryCode: response.data, pageSize: 10000 }).then(
            (res) => {
              this.loading = false;
              this.equipmentList = res.rows || []
              if(res.rows && res.rows.length){
                this.equipmentIndex = 0
              }
              this.refreshType();
            }
          );
        });
    },
     selectHdl(index){
      return new Promise(resolve =>{
        let { equipmentList } = this
        if(!equipmentList.length){
          resolve(null)
          return
        }
        getCarflow(this.equipmentList[index].id).then((response) => {
          resolve(response)
          if(response.code == 200 && response.data){
            let data = response.data
            this.inCountNum = data.inCountNum
            this.outCountNum = data.outCountNum
            this.info = data.equipment
          }else{
            this.inCountNum = 0
            this.outCountNum = 0
          }
        }).catch(() =>{
          resolve(null)
        });
      })
    },
  },
  beforeDestroy() {
    this.submitIsShowbg(true);
    clearInterval(this.interval);
  },
};
</script>
<style scoped lang="scss">
// @import "~@/theme-default/src/mixin.scss";
.container-wrap{
  display:flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 getWidth(40);
  box-sizing: border-box;
  .container-left{
    width:getWidth(446);
    .card01{ 
      width:100%;
      height:getHeight(261);
    }
    .card02{ 
      margin-top:getHeight(20);
      width:100%;
      height:getHeight(376);
      .card01-1{
        width:100%;
        height:getHeight(90);
        display: flex;
        align-items: center;
        padding-left: getWidth(35);
        box-sizing: border-box;
      }
      .card01-2{
        width: 100%;
        height: getHeight(266);
      }
    }
  }
  .container-middle{
    width:getWidth(868);
    height:getHeight(898);
  }
  .container-right{
    width:getWidth(446);
    .right01{
      width:100%;
      height:getHeight(90);
    }
    .right02{
      margin-top:getHeight(31);
      width:100%;
      height:getHeight(341);
      .info-wrap{
        padding:getWidth(30);
        box-sizing: border-box;
        .select-scenic-list{
          width:100%;
          ::v-deep{
            .el-input__inner{
              background-color: transparent;
              border-radius: px2rem(10);
              border: 1px solid #7DFFFF;
              box-sizing: border-box;
              color: #7DFFFF;
              height: getHeight(44);
              line-height: getHeight(44);
              padding: 0 getHeight(18);
              width:100%
            }
            .el-input__suffix{
              background-color: transparent;
            }
            .el-select__caret{
              color: #7DFFFF;
            }
          }
        }
        .address-wrap{
          display: flex;
          align-items: center;
          margin-top:getHeight(18);
          font-size: px2rem(14);
          font-family: PingFangSC-Bold;
          font-weight: bold;
          color: #7DFFFF;
          img{
            margin-right: getWidth(7);
            width:getWidth(28);
          }
        }
        .status-wrap{
          display: flex;
          align-items: center;
          margin-top:getHeight(12);
          font-size: px2rem(14);
          font-family: PingFangSC-Bold;
          font-weight: bold;
          color: #0AF644;
          img{
            width:getWidth(21);
            margin-right: getWidth(14);
          }
        }
        .count-wrap{
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: getHeight(27);
          >div{
            width: getWidth(185);
            height: getHeight(80);
            border-radius: px2rem(3);
            display: flex;
            img{
              width: getWidth(55);
              height:100%;
            }
            .count-info{
              width: getWidth(108);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: space-around;
              .count-title{
                font-size: px2rem(14);
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: #FFFFFF;
              }
              .count-num{
                font-size: px2rem(24);
                font-family: PingFangSC-Bold;
                font-weight: bold;
                color: #FFFFFF;
              }
            }
          }
          .enter{
            background: rgba(100, 164, 216, 0.2);
          }
          .outer{
            background: rgba(255, 113, 103, 0.2);
          }
        }
      }
    }
  }
}
  .video-dialog{
    background: rgba(1,25,58,.9);
    // backdrop-filter: blur(2px);
    z-index: 9999999 !important;
    ::v-deep{
      .el-dialog {
        background-image: unset !important;
        padding: 0 0 !important;
      }
      .el-dialog__header{
        display: none;
      }
      .el-dialog__body{
        padding: 0 0;
      }
    }
  }
</style>
